import React, { useEffect, useState, useCallback } from 'react';
import Sidebar from '../../components/Sidebar';
import './advogado.css';
import { useUsers } from '../../context/usersContext';
import { useInternals } from '../../context/internalContext';
import { toast } from 'react-toastify';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import Modal from '../../components/modal';
import SearchInternal from '../../components/SearchInternal/SearchInternal';
import useSubmitLock from '../../utils/useSubmitLock';
import InternalPhoto from '../../components/InternalPhoto';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import ConfirmModal from '../../components/modal/confirmModal';
import ReactPaginate from 'react-paginate';

const TYPE_SCHEDULE_ADVOGADO = 11;
const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

function Advogado() {
  const { userInfo } = useUsers();
  const { listSchedule, createSchedule, listInternalImage, updateSchedule } = useInternals();

  const [appointments, setAppointments] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedInternal, setSelectedInternal] = useState(null);
  const [internalImagePreview, setInternalImagePreview] = useState(null);
  const [selectedAppointmentToCancel, setSelectedAppointmentToCancel] = useState(null);
  const [selectedAppointmentToAttend, setSelectedAppointmentToAttend] = useState(null);
  const [reasonInactivation, setReasonInactivation] = useState('');
  const [formData, setFormData] = useState({
    start_date: '',
    start_time: '',
    end_time: '',
    observation: '',
    virtual: false
  });
  const { isSubmitting, runWithSubmitLock } = useSubmitLock();
  const [isLoading, setIsLoading] = useState(false);

  const fetchAppointments = useCallback(async () => {
    try {
      const response = await listSchedule({
        user: userInfo.id,
        limit: pageSize,
        offset: currentPage * pageSize,
      });
      if (response && Array.isArray(response.results)) {
        setAppointments(response.results);
        setTotalItems(response.count ?? 0);
      } else {
        toast.error('Erro ao buscar agendamentos.');
      }
    } catch (error) {
      toast.error('Erro ao buscar seus agendamentos.');
    }
  }, [listSchedule, userInfo.id, pageSize, currentPage]);

  useEffect(() => {
    fetchAppointments();
  }, [fetchAppointments]);

  const handlePageClick = ({ selected }) => setCurrentPage(selected);

  const pageCount = Math.ceil(totalItems / pageSize) || 0;

  const getStatusBadge = (appointment) => {
    if (!appointment.active && appointment.reason_inactivation) return { label: 'CANCELADO', className: 'status-canceled' };
    if (appointment.done) return { label: 'ATENDIDO', className: 'status-done' };
    if (appointment.deadline_status === 'Vencido') return { label: 'VENCIDO', className: 'status-expired' };
    if (appointment.deadline_status === 'Vencendo') return { label: 'VENCENDO', className: 'status-warning' };
    if (appointment.status_name === 'SOLICITADO') return { label: 'SOLICITADO', className: 'status-pending' };
    return { label: appointment.status_name || 'AGENDADO', className: 'status-active' };
  };

  const handleInternalSelect = async (internal) => {
    if (!internal?.id) return;
    setSelectedInternal(internal);
    try {
      const response = await listInternalImage(internal.id);
      if (response && response.data) {
        const mainImg = response.data.find(img => img.main === true);
        setInternalImagePreview(mainImg || null);
      } else {
        setInternalImagePreview(null);
      }
    } catch (error) {
      console.error("Erro ao buscar imagem do interno:", error);
      setInternalImagePreview(null);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      if (!selectedInternal) return toast.warn('Selecione um interno.');

      const startDateTime = `${formData.start_date}T${formData.start_time}:00`;
      const endDateTime = `${formData.start_date}T${formData.end_time}:00`;

      if (new Date(endDateTime) <= new Date(startDateTime)) {
        toast.error('O horário de término deve ser posterior ao horário de início.');
        return;
      }

      const payload = {
        start_date: startDateTime,
        end_date: endDateTime,
        user: userInfo.id,
        internal: selectedInternal.id,
        type_schedule: TYPE_SCHEDULE_ADVOGADO,
        observation: formData.observation,
        virtual: formData.virtual,
      };

      try {
        await createSchedule(payload);
        setCurrentPage(0);
        fetchAppointments();
        setIsModalOpen(false);
        setSelectedInternal(null);
        setInternalImagePreview(null);
        setFormData({ start_date: '', start_time: '', end_time: '', observation: '', virtual: false });
      } catch (error) {
        toast.error('Erro ao criar agendamento.');
      }
    });
  };

  const handleMarkAsAttended = async () => {
    if (!selectedAppointmentToAttend) return;
    setIsLoading(true);
    try {
      await runWithSubmitLock(async () => {
        await updateSchedule(selectedAppointmentToAttend.id, { done: true });
        setSelectedAppointmentToAttend(null);
        fetchAppointments();
      });
    } catch (error) {
      toast.error('Erro ao marcar agendamento como realizado.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelAppointment = async () => {
    if (!selectedAppointmentToCancel) return;
    if (!reasonInactivation.trim()) {
      toast.warn('Por favor, insira um motivo para o cancelamento.');
      return;
    }
    if (reasonInactivation.trim().length < 10) {
      toast.warn('O motivo do cancelamento deve ter pelo menos 10 caracteres.');
      return;
    }
    setIsLoading(true);
    try {
      await runWithSubmitLock(async () => {
        await updateSchedule(selectedAppointmentToCancel.id, {
          active: false,
          reason_inactivation: reasonInactivation.trim(),
        });
        toast.success('Agendamento cancelado com sucesso!');
        setReasonInactivation('');
        setSelectedAppointmentToCancel(null);
        fetchAppointments();
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Sidebar />
      <Header />
      <div className='container'>
        <Titulo
          children={<h2>Agendamentos</h2>}
          children2={
            <button className="btnAdcionar" onClick={() => setIsModalOpen(true)}>
              Solicitar Agendamento
            </button>
          }
        />

        <div className='content'>
          {appointments.length > 0 ? (
            <div className="appointments-grid">
              {appointments.map((appointment) => {
                const status = getStatusBadge(appointment);
                const isSolicitado = appointment.status_name === 'SOLICITADO';
                return (
                  <div key={appointment.id} className="appointment-card">
                    <div className="adv-card-header">
                      <div className="adv-card-badge-row">
                        <span className={`appointment-status-badge ${status.className}`}>
                          {status.label}
                        </span>
                      </div>
                      <div className="adv-card-header-info">
                        <p className="adv-card-internal-name">{appointment.internal_name || 'N/A'}</p>
                        <p className="adv-card-unit-name">{appointment.unit || 'N/A'}</p>
                      </div>
                    </div>
                    <div className="appointment-card-info">
                      <div className="appointment-info-item">
                        <strong>Data:</strong>
                        <span>{new Date(appointment.start_date).toLocaleDateString('pt-BR')}</span>
                      </div>
                      <div className="appointment-info-item">
                        <strong>Horário:</strong>
                        <span>{new Date(appointment.start_date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
                      </div>
                      <div className="appointment-info-item">
                        <strong>Tipo:</strong>
                        <span className={appointment.virtual ? 'tag-virtual' : 'tag-presencial'}>
                          {appointment.virtual ? 'Virtual' : 'Presencial'}
                        </span>
                      </div>
                      {appointment.observation && (
                        <div className="adv-observation">
                          <strong>Observação</strong>
                          <p>{appointment.observation}</p>
                        </div>
                      )}
                      {appointment.reason_inactivation && (
                        <div className="adv-cancel-reason">
                          <strong>Motivo Cancelamento</strong>
                          <p>{appointment.reason_inactivation}</p>
                        </div>
                      )}
                    </div>
                    <div className="appointment-card-footer">
                      <button
                        className="btn-action-complete"
                        title="Marcar como realizado"
                        onClick={() => setSelectedAppointmentToAttend(appointment)}
                        disabled={appointment.done || !appointment.active || isSolicitado || isLoading}
                      >
                        <FontAwesomeIcon icon={faCheckCircle} /> Marcar como Realizado
                      </button>
                      <button
                        className="btn-action-delete"
                        title="Cancelar agendamento"
                        onClick={() => setSelectedAppointmentToCancel(appointment)}
                        disabled={appointment.done || !appointment.active}
                      >
                        <FontAwesomeIcon icon={faBan} /> Cancelar
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <p className='no-appointments'>Nenhum agendamento encontrado.</p>
          )}
        </div>

        <div className="pagination-options">
          <div>
            <label>Itens por página</label>
            <select
              value={pageSize}
              onChange={(e) => {
                setPageSize(Number(e.target.value));
                setCurrentPage(0);
              }}
            >
              {PAGE_SIZE_OPTIONS.map((opt) => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          </div>
          {pageCount > 1 && (
            <ReactPaginate
              previousLabel={'<'}
              nextLabel={'>'}
              breakLabel={'...'}
              pageCount={pageCount}
              pageRangeDisplayed={3}
              marginPagesDisplayed={1}
              onPageChange={handlePageClick}
              containerClassName={'pagination'}
              activeClassName={'activeNumber'}
              previousClassName={'prev'}
              nextClassName={'next'}
              pageClassName={'page'}
              breakClassName={'break-me'}
              forcePage={currentPage}
            />
          )}
        </div>

        {/* Modal de criação de agendamento */}
        <Modal isOpen={isModalOpen} closeModal={() => setIsModalOpen(false)} title="Criar Agendamento">
          <Titulo children={<SearchInternal onSelect={handleInternalSelect} />} />
          <form className='appointment-form' onSubmit={handleSubmit}>
            <div className="appointment-selected-internal">
              <p className="appointment-details-label">Interno selecionado</p>
              {selectedInternal ? (
                <div className="appointment-internal-preview">
                  <InternalPhoto image={internalImagePreview} alt="Perfil" className="appointment-internal-image-preview" />
                  <div className="appointment-internal-info-preview">
                    <strong>{selectedInternal.name}</strong>
                    <span>CPF: {selectedInternal.cpf}</span>
                  </div>
                </div>
              ) : (
                <p className='h4-title'>Nenhum interno selecionado</p>
              )}
            </div>

            <label>Data:</label>
            <input type='date' name='start_date' value={formData.start_date} onChange={handleInputChange} required />

            <div className='form-group-duplo'>
              <div className='form-group'>
                <label>Horário de Início:</label>
                <input type='time' name='start_time' value={formData.start_time} onChange={handleInputChange} required />
              </div>
              <div className='form-group'>
                <label>Horário de Fim:</label>
                <input type='time' name='end_time' value={formData.end_time} onChange={handleInputChange} required />
              </div>
            </div>

            <label>Observações:</label>
            <textarea name='observation' value={formData.observation} onChange={handleInputChange} />

            <label className="checkbox-label-process">
              <input type='checkbox' name='virtual' checked={formData.virtual} onChange={handleInputChange} /> Atendimento Virtual
            </label>

            <button type='submit' disabled={isSubmitting}>
              {isSubmitting ? 'Salvando...' : 'Salvar'}
            </button>
          </form>
        </Modal>

        {/* Modal de confirmação para marcar como realizado */}
        <ConfirmModal
          isOpen={!!selectedAppointmentToAttend}
          closeModal={() => setSelectedAppointmentToAttend(null)}
          onConfirm={handleMarkAsAttended}
          icon={faCheckCircle}
          mainMessage="Confirmar Realização"
          secondaryMessage="Tem certeza que deseja marcar este agendamento como realizado?"
          loading={isLoading}
        />

        {/* Modal de confirmação para cancelar agendamento */}
        <ConfirmModal
          isOpen={!!selectedAppointmentToCancel}
          closeModal={() => setSelectedAppointmentToCancel(null)}
          onConfirm={handleCancelAppointment}
          icon={faBan}
          mainMessage="Tem certeza que deseja cancelar este agendamento?"
          secondaryMessage="Essa ação não pode ser desfeita."
          loading={isLoading}
        >
          <div style={{ marginTop: '20px' }}>
            <label htmlFor="cancel-reason">Motivo do Cancelamento:</label>
            <textarea
              id="cancel-reason"
              name="reason_inactivation"
              value={reasonInactivation}
              onChange={(e) => setReasonInactivation(e.target.value)}
              placeholder="Digite o motivo do cancelamento (mínimo 10 caracteres)"
              required
              rows="4"
              disabled={isLoading}
            />
          </div>
        </ConfirmModal>
      </div>
    </div>
  );
}

export default Advogado;
